module.exports = __webpack_public_path__ + "public/adminIcons/dlt.png?b362cae0";